// Date 2020-10-05 06:46:06

import sithMesPrdDispatchWorks from "@/store/sithMes/prd/SithMesPrdDispatchWorksStore.js";

const genericEntities = [
    'sithMesPrdDispatchWorks'
]

const entities = {
    sithMesPrdDispatchWorks
}

export {genericEntities}

export default entities